export default "__VITE_ASSET__BKnraCLD__"